import * as core from '../../../../../../../core'
import * as changeImpactYesNoNa from '../change-impact-yes-no-na'

export const RESOURCE = {
  payload: {
    description: 'No',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactYesNoNa.RESOURCE.payload.partialId,
    }),
    id: 'No',
    name: 'No',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
